<div id="st-breakdown-filter-sidebar-sidebar-container" class="sidebar-container">
  <svg class="icon-sprite" aria-hidden="true" focusable="false">
    <defs>
      <symbol id="icon-close" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" d="M18 6 6 18M6 6l12 12" /></symbol>
      <symbol id="icon-filter" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" stroke-linecap="round" d="M3 5h18l-7 8v6l-4 2v-8z" /></symbol>
      <symbol id="icon-arrow-right" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M4.5 12h15M13 6l6 6-6 6" /></symbol>
    </defs>
  </svg>

  <header id="st-breakdown-filter-sidebar-header" class="sidebar-header d-flex align-items-center justify-content-between py-3 px-4">
    <div id="st-breakdown-filter-sidebar-header-content" class="header-content d-flex align-items-center gap-2">
      <span class="header-icon" aria-hidden="true">
        <svg width="16" height="16" viewBox="0 0 24 24"><use href="#icon-filter" /></svg>
      </span>
      <h2 class="fs-16 fw-bold m-0">{{ 'filter' | translate }}</h2>
      <span class="header-count-badge fs-10 fw-medium" *ngIf="getTotalSelectedFilterCount() > 0">{{ getTotalSelectedFilterCount() }}</span>
    </div>
    <button class="close-btn" (click)="closeSidebar()" [attr.aria-label]="'close' | translate">
      <svg width="12" height="12" viewBox="0 0 24 24" aria-hidden="true"><use href="#icon-close" /></svg>
    </button>
  </header>
  <div id="st-breakdown-filter-sidebar-sidebar-content" class="sidebar-content">
    <nav id="st-breakdown-filter-sidebar-left-pane" class="left-pane d-flex flex-column p-3 gap-1">
      <button id="st-breakdown-filter-sidebar-tab-status" class="nav-item" [class.active]="activeTab === 'playerCategory'" (click)="setActiveTab('playerCategory')">
        <span class="nav-label fs-12 fw-medium">{{ 'active_inactive' | translate }}</span>
        <span *ngIf="getSelectedPlayerCategoryCount() > 0" class="nav-badge fs-10 fw-medium">
          {{ getSelectedPlayerCategoryCount() }}
        </span>
      </button>
      <ng-container *ngIf="getDisplayableRoles().length > 0">
        <button *ngFor="let role of getDisplayableRoles(); trackBy: trackById" class="nav-item"
          [class.active]="activeTab === 'club' && activeRoleId === role.parent_role_id"
          (click)="setActiveRoleTab(role.parent_role_id)">
          <span class="nav-label fs-12 fw-medium">{{ role.parent_role_name }}</span>
          <span *ngIf="getSelectedCountForRole(role) > 0" class="nav-badge fs-10 fw-medium">
            {{ getSelectedCountForRole(role) }}
          </span>
        </button>
      </ng-container>
      <div class="nav-divider" aria-hidden="true"></div>
      <!-- <ng-container *ngIf="getDisplayableRoles().length === 0">
        <button
          class="tab"
          [class.active]="activeTab === 'club'"
          (click)="setActiveTab('club')"
        >
          {{ 'club' | translate }}/MA
        </button>
      </ng-container> -->
      <!-- Rating Period — admin-gated (filter configuration); dataset swap,
           not a row filter -->
      <button *ngIf="isRatingPeriodEnabled" class="nav-item" [class.active]="activeTab === 'period'" (click)="setActiveTab('period')">
        <span class="nav-label fs-12 fw-medium">{{ 'rating_period' | translate }}</span>
        <span *ngIf="getSelectedPeriodCount() > 0" class="nav-badge fs-10 fw-medium">
          {{ getSelectedPeriodCount() }}
        </span>
      </button>
      <button class="nav-item" [class.active]="activeTab === 'rank'" (click)="setActiveTab('rank')">
        <span class="nav-label fs-12 fw-medium">{{ 'rank' | translate }}</span>
        <span *ngIf="getSelectedRankCount() > 0" class="nav-badge fs-10 fw-medium">
          {{ getSelectedRankCount() }}
        </span>
      </button>
      <button *ngIf="filterConfig.enable_age_filter" class="nav-item" [class.active]="activeTab === 'age'"
        (click)="setActiveTab('age')">
        <span class="nav-label fs-12 fw-medium">{{ 'age' | translate }}</span>
        <span *ngIf="getSelectedAgeCount() > 0" class="nav-badge fs-10 fw-medium">
          {{ getSelectedAgeCount() }}
        </span>
      </button>
      <!-- Classification filters (e.g. Para) — admin-gated, tenant-defined -->
      <div class="nav-divider" *ngIf="getVisibleClassificationFields().length > 0" aria-hidden="true"></div>
      <button *ngFor="let clsField of getVisibleClassificationFields(); trackBy: trackById" class="nav-item"
        [class.active]="activeTab === clsField.name" (click)="setActiveTab(clsField.name)">
        <span class="tab-label">{{ clsField.name }}</span>
        <span class="filter-count-badge">
          {{ 'x_of_y' | translate:{selected: getSelectedCountForClassification(clsField), total: clsField.values.length} }}
        </span>
      </button>

    </nav>
    <div id="st-breakdown-filter-sidebar-right-pane" class="right-pane d-flex flex-column p-4 gap-3">
      <!-- Player Category (Active/Inactive) Filter -->
      <div id="st-breakdown-filter-sidebar-block-player-category" *ngIf="activeTab === 'playerCategory'">
        <div class="panel-header d-flex align-items-center gap-2">
          <h3 class="fs-14 fw-semibold m-0">{{ 'filter_by_status' | translate }}</h3>
        </div>
        <div id="st-breakdown-filter-sidebar-player-category-options" class="segmented-control mt-3">
          <label *ngFor="let option of playerCategoryOptions; trackBy: trackByPlayerCategory" class="segmented-option fs-12 fw-medium"
            [class.active]="selectedPlayerCategory === option.value">
            <input
              type="radio"
              name="playerCategory"
              [value]="option.value"
              [checked]="selectedPlayerCategory === option.value"
              (change)="onPlayerCategorySelect(option.value)"
              class="chip-input"
            />
            <span>{{ option.labelKey | translate }}</span>
          </label>
        </div>
      </div>
      <!-- Club Filter -->
      <div id="st-breakdown-filter-sidebar-block" *ngIf="activeTab === 'club'">
        <ng-container *ngIf="getDisplayableRoles().length > 0 && getActiveRole(); else clubFallback">
          <div class="panel-header d-flex align-items-center gap-2">
            <h3 class="fs-14 fw-semibold m-0">{{ 'filter_by' | translate }} {{ getActiveRole()?.parent_role_name }}</h3>
          </div>
          <div id="st-breakdown-filter-sidebar-search-container" class="search-container mt-3 mb-3">
            <img src="../../../../assets/ranking-rating_assets/search_icon_p3.svg" alt="Search Icon"
              class="search-icon" />
            <input type="text"
              [placeholder]="'search_for_name' | translate:{name: getActiveRole()?.parent_role_name || 'Clubs'}"
              class="search-input fs-13 fw-medium" [(ngModel)]="searchValue" (input)="onSearch()" />
            <button type="button" class="search-clear-btn" *ngIf="searchValue" (click)="searchValue=''; onSearch()" aria-label="Clear">
              <svg width="10" height="10" viewBox="0 0 24 24" aria-hidden="true"><use href="#icon-close" /></svg>
            </button>
          </div>
          <div id="st-breakdown-filter-sidebar-club-options" class="club-options d-flex flex-column gap-2" *ngIf="filteredRoleEntities.length > 0; else noResults">
            <label *ngFor="let entity of filteredRoleEntities; trackBy: trackById" class="club-option fs-12 fw-normal"
              [class.active]="isRoleEntitySelected(entity.parent_user_role_id)">
              <input type="checkbox" [checked]="isRoleEntitySelected(entity.parent_user_role_id)"
                (change)="onRoleEntitySelect(entity.parent_user_role_id)" />
              <span class="avatar-initial fs-10 fw-semibold" aria-hidden="true">{{ getInitials(entity.parent_role_linked_field_value) }}</span>
              <span class="option-label">{{ entity.parent_role_linked_field_value }}</span>
            </label>
          </div>
          <ng-template #noResults>
            <div class="empty-state">
              <img src="../../../../assets/ranking-rating_assets/no_record_found.svg" alt="" class="empty-state-icon" />
              <p class="fs-12 fw-normal m-0">{{ 'no_records_found_for_name' | translate:{name: getActiveRole()?.parent_role_name || 'Clubs'} }}</p>
            </div>
          </ng-template>
        </ng-container>
        <ng-template #clubFallback>
          <div class="panel-header d-flex align-items-center gap-2">
            <h3 class="fs-14 fw-semibold m-0">{{ 'filter_by_club' | translate }}/MA</h3>
          </div>
          <div id="st-breakdown-filter-sidebar-search-container-1" class="search-container mt-3 mb-3">
            <img src="../../../../assets/ranking-rating_assets/search_icon_p3.svg" alt="Search Icon"
              class="search-icon" />
            <input type="text" [placeholder]="'search_for_name' | translate:{name: 'Clubs'}" [(ngModel)]="searchValue"
              (input)="onSearch()" class="search-input fs-13 fw-medium" />
            <button type="button" class="search-clear-btn" *ngIf="searchValue" (click)="searchValue=''; onSearch()" aria-label="Clear">
              <svg width="10" height="10" viewBox="0 0 24 24" aria-hidden="true"><use href="#icon-close" /></svg>
            </button>
          </div>
          <div id="st-breakdown-filter-sidebar-club-options-2" class="club-options d-flex flex-column gap-2" *ngIf="clubs.length > 0; else noResultsFallback">
            <label *ngFor="let club of clubs; trackBy: trackById" class="club-option fs-12 fw-normal" [class.active]="selectedClubs[club.user_role_id]">
              <input type="checkbox" [checked]="selectedClubs[club.user_role_id]"
                (change)="onClubSelect(club.user_role_id)" />
              <span class="avatar-initial fs-10 fw-semibold" aria-hidden="true">{{ getInitials(club.name) }}</span>
              <span class="option-label">{{ club.name }}</span>
            </label>
          </div>
          <ng-template #noResultsFallback>
            <div class="empty-state">
              <img src="../../../../assets/ranking-rating_assets/no_record_found.svg" alt="" class="empty-state-icon" />
              <p class="fs-12 fw-normal m-0">{{ 'no_records_found_for_name' | translate:{name: 'Clubs'} }}</p>
            </div>
          </ng-template>
        </ng-template>
      </div>
      <!-- Period Filter -->
      <div id="st-breakdown-filter-sidebar-block-3" *ngIf="activeTab === 'period'">
        <div class="panel-header d-flex align-items-center gap-2">
          <h3 class="fs-14 fw-semibold m-0">{{ 'filter_by_date' | translate }}</h3>
        </div>
        <!-- <select
          class="season-dropdown"
          [(ngModel)]="selectedSeasonId"
          (ngModelChange)="onSeasonChange($event, 'period')"
        >
          <option *ngFor="let season of seasons; trackBy: trackById" [value]="season.id">
            {{ season.season_name }}
          </option>
        </select> -->
        <div id="st-breakdown-filter-sidebar-timeline-options-list" class="timeline-options-list d-flex flex-column gap-2 mt-3" *ngIf="publishedDates && publishedDates.length > 0; else noPeriods">
          <label *ngFor="let item of publishedDates; trackBy: trackById; let i = index" class="timeline-option fs-12 fw-normal"
            [class.active]="selectedTimelineId === item">
            <input type="radio" name="timeline" [value]="item" [(ngModel)]="selectedTimelineId"
              (ngModelChange)="onPeriodChange()" />
            <span class="option-label">{{ item | date: 'dd/MM/yyyy, HH:mm' }}</span>
            <span class="latest-badge fs-10 fw-medium" *ngIf="i === 0">{{ 'latest' | translate }}</span>
          </label>
        </div>
        <ng-template #noPeriods>
          <div class="empty-state">
            <img src="../../../../assets/ranking-rating_assets/no_record_found.svg" alt="" class="empty-state-icon" />
            <p class="fs-12 fw-normal m-0">{{ 'no_data_available' | translate }}</p>
          </div>
        </ng-template>
      </div>
      <!-- Rank Filter -->
      <div id="st-breakdown-filter-sidebar-block-4" *ngIf="activeTab === 'rank'">
        <div class="panel-header d-flex align-items-center gap-2">
          <h3 class="fs-14 fw-semibold m-0">{{ 'filter_by_rank' | translate }}</h3>
        </div>
        <div id="st-breakdown-filter-sidebar-rank-options" class="chip-grid mt-3">
          <label *ngFor="let option of filteredRankOptions; trackBy: trackById" class="chip fs-12 fw-medium" [class.active]="selectedRank === option">
            <input type="radio" name="rank" [value]="option" [(ngModel)]="selectedRank"
              (change)="onRankSelect(option)" class="chip-input" />
            <span>{{ option }}</span>
          </label>
        </div>
      </div>
      <!-- Event Filter -->
      <div id="st-breakdown-filter-sidebar-block-5" *ngIf="activeTab === 'event'">
        <div class="panel-header d-flex align-items-center gap-2">
          <h3 class="fs-14 fw-semibold m-0">{{ 'filter_by_event' | translate }}</h3>
        </div>
        <!-- <select
          class="season-dropdown"
          [(ngModel)]="eventTabSeasonId"
          (ngModelChange)="onSeasonChange($event, 'event')"
        >
          <option *ngFor="let season of seasons" [value]="season.id">
            {{ season.season_name }}
          </option>
        </select> -->
        <div id="st-breakdown-filter-sidebar-event-options" class="event-options d-flex flex-column gap-2 mt-3" *ngIf="events.length > 0; else noEventResults">
          <label *ngFor="let event of events; trackBy: trackById" class="event-option fs-12 fw-normal" [class.active]="event.checked">
            <input type="checkbox" [checked]="event.checked" (change)="onEventSelect(event)" />
            <span class="option-label">{{ event.event_name }}</span>
          </label>
        </div>
        <ng-template #noEventResults>
          <div class="empty-state">
            <img src="../../../../assets/ranking-rating_assets/no_record_found.svg" alt="" class="empty-state-icon" />
            <p class="fs-12 fw-normal m-0">{{ 'no_events_found' | translate }}</p>
          </div>
        </ng-template>
      </div>
      <!-- Gender Filter -->
      <div id="st-breakdown-filter-sidebar-block-6" *ngIf="activeTab === 'gender'">
        <div class="panel-header d-flex align-items-center gap-2">
          <h3 class="fs-14 fw-semibold m-0">{{ 'filter_by_gender' | translate }}</h3>
        </div>
        <div id="st-breakdown-filter-sidebar-gender-options" class="gender-options d-flex flex-column gap-2 mt-3">
          <label class="gender-option fs-12 fw-normal" [class.active]="selectedGenders['Male']">
            <input type="checkbox" [checked]="selectedGenders['Male']" (change)="onGenderSelect('Male')" />
            <span class="option-label">{{ 'male' | translate }}</span>
          </label>
          <label class="gender-option fs-12 fw-normal" [class.active]="selectedGenders['Female']">
            <input type="checkbox" [checked]="selectedGenders['Female']" (change)="onGenderSelect('Female')" />
            <span class="option-label">{{ 'female' | translate }}</span>
          </label>
        </div>
      </div>
      <!-- Age Filter -->
      <div id="st-breakdown-filter-sidebar-block-7" *ngIf="activeTab === 'age'">
        <div class="panel-header d-flex align-items-center gap-2">
          <h3 class="fs-14 fw-semibold m-0">{{ 'filter_by_age' | translate }}</h3>
        </div>
        <div id="st-breakdown-filter-sidebar-age-options" class="chip-grid mt-3">
          <label *ngFor="let age of ageOptions; trackBy: trackById" class="chip fs-12 fw-medium" [class.active]="selectedAges[age]">
            <input type="checkbox" [checked]="selectedAges[age]" (change)="onAgeSelect(age)" class="chip-input" />
            <span>{{ age }}</span>
          </label>
        </div>
      </div>
      <!-- Classification Filter (e.g. Para) — a normal multi-select: "None"
           is a selectable value for non-classified players, so checking a
           single class isolates exactly that class; unticking every value
           matches nobody -->
      <div id="st-breakdown-filter-sidebar-block-classification" *ngIf="getActiveClassificationField() as clsField">
        <div class="panel-header d-flex align-items-center gap-2">
          <h3 class="fs-14 fw-semibold m-0">{{ 'filter_by' | translate }} {{ clsField.name }}</h3>
        </div>
        <div id="st-breakdown-filter-sidebar-classification-search" class="search-container mt-3 mb-3">
          <img src="../../../../assets/ranking-rating_assets/search_icon_p3.svg" alt="Search Icon"
            class="search-icon" />
          <input type="text" class="search-input fs-13 fw-medium"
            [placeholder]="'search_for_name' | translate:{name: clsField.name}"
            [(ngModel)]="classificationSearch[clsField.name]" />
          <button type="button" class="search-clear-btn" *ngIf="classificationSearch[clsField.name]" (click)="classificationSearch[clsField.name]=''" aria-label="Clear">
            <svg width="10" height="10" viewBox="0 0 24 24" aria-hidden="true"><use href="#icon-close" /></svg>
          </button>
        </div>
        <label id="st-breakdown-filter-sidebar-classification-select-all" class="select-all-option fs-12 fw-semibold mt-2 mb-2"
          [class.active]="areAllClassificationValuesSelected(clsField)">
          <input type="checkbox" [checked]="areAllClassificationValuesSelected(clsField)"
            (change)="toggleSelectAllClassification(clsField)" />
          <span class="option-label">{{ 'select_all' | translate }}</span>
        </label>
        <div id="st-breakdown-filter-sidebar-classification-options" class="club-options d-flex flex-column gap-2"
          *ngIf="getFilteredClassificationValues(clsField).length > 0; else noClassResults">
          <label *ngFor="let value of getFilteredClassificationValues(clsField); trackBy: trackById" class="club-option fs-12 fw-normal"
            [class.active]="selectedClassValues[clsField.name]?.[value]">
            <input type="checkbox" [checked]="selectedClassValues[clsField.name]?.[value]"
              (change)="onClassValueSelect(clsField.name, value)" />
            {{ displayLabel(clsField, value) }}
          </label>
        </div>
        <ng-template #noClassResults>
          <div class="empty-state">
            <img src="../../../../assets/ranking-rating_assets/no_record_found.svg" alt="" class="empty-state-icon" />
            <p class="fs-12 fw-normal m-0">{{ 'no_records_found_for_name' | translate:{name: clsField.name} }}</p>
          </div>
        </ng-template>
      </div>
      <!-- Category Filter -->
      <div id="st-breakdown-filter-sidebar-block-8" *ngIf="activeTab === 'category'">
        <div class="panel-header d-flex align-items-center gap-2">
          <h3 class="fs-14 fw-semibold m-0">{{ 'filter_by_category' | translate }}</h3>
        </div>
        <select class="category-level-dropdown fs-13 fw-medium mt-3 mb-3" [(ngModel)]="selectedCategoryLevelName"
          (ngModelChange)="onCategoryLevelSelect($event)">
          <!-- <option [ngValue]="null" [value]="null">Select Level</option> -->
          <option *ngFor="let level of categoryLevels; trackBy: trackById" [value]="level.level">
            {{ level.level }}
          </option>
        </select>
        <div id="st-breakdown-filter-sidebar-category-options" class="category-options d-flex flex-column gap-2 mt-0" *ngIf="categoriesForFilter.length > 0">
          <label *ngFor="let category of categoriesForFilter; trackBy: trackById" class="category-option fs-12 fw-normal"
            [class.active]="selectedCategoryId === category.id">
            <input type="radio" name="category" [value]="category.id" [(ngModel)]="selectedCategoryId" />
            <span class="option-label">{{ category.category_description | truncate:15:'...' }}</span>
          </label>
        </div>
      </div>
    </div>
  </div>
  <div id="st-breakdown-filter-sidebar-sidebar-footer" class="sidebar-footer d-flex align-items-center justify-content-end gap-2 py-2 px-4">
    <button class="clear-btn fs-12 fw-medium" (click)="clearFilters()">
      {{ 'clear_all' | translate }}
      <span class="footer-count-badge fs-10 fw-medium" *ngIf="getTotalSelectedFilterCount() > 0">{{ getTotalSelectedFilterCount() }}</span>
    </button>
    <button class="apply-btn fs-13 fw-semibold" (click)="applyFiltersHandler()">
      {{ 'apply' | translate }}
      <svg width="12" height="12" viewBox="0 0 24 24" aria-hidden="true"><use href="#icon-arrow-right" /></svg>
    </button>
  </div>
</div>
